import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import HomeSection from './HomeSection';
import HomeSectionBranched from '../HomeSection.deviation_gruser';
import HomeSectionContainer from './HomeSection.container';

export default withFeatureBranch({
  deviation_gruser_port: HomeSectionBranched,
})(HomeSectionContainer(HomeSection));
